module.exports = __webpack_public_path__ + "static/img/af.e896383.png";


//////////////////
// WEBPACK FOOTER
// ./src/flag/af.png
// module id = 1iP4
// module chunks = 0